import ErrorStackParser from "error-stack-parser";
//import $ from 'jquery';
//import bootbox from 'bootbox';

//var bootstrap = require('bootstrap');

const statusSuccess = 'success';

export const Globals = (function () {
    const APIFolder = "/api/v1.0";

    function Globals()
    {
    }

    Object.defineProperty(Globals, "APIFolder", {
        get: function () {
            return "https://" + document.location.hostname + APIFolder;
        }
    });

    Object.defineProperty(Globals, "BaseURL", {
        get: function () {
            return "https://" + document.location.hostname;
        }
    });

    return Globals;
})();

export const getDataWithPromise = (url, type, data) => {
    return new Promise((resolve, reject) => {
        if (url == null || url === "")
        {
            throw Error("getDataWithPromise cannot call an empty URL");
        }
        else
        {
            $.ajax({
                type: type,
                url: url,
                data: data,
                success: (data) => {
                    if (checkError(data))
                    {
                        resolve(data);
                    }
                },
                error: (jqXHR, textStatus, error) => {
                    reject(jqXHR, textStatus, error);
                }
            });
        }
    });
};

/*
export const getStatusFromResponse = (response) => {
  return response.status;
};

export const getDataFromResponse = (response) => {
  if (response.data !== undefined && response.data != null) {
    return response.data;
  } else {
    return [];
  }
};

export const getNumRowsFromResponse = (response) => {
  return response.status.rowsAffected;
};

 */

export const getStatusFromResponse = (response) =>
{
    return response.result;
}

export const getErrorFromResponse = (response) =>
{
    return response.Error;
}

export const getExceptionClassFromResponse = (response) =>
{
    if (response.exceptionClass !== undefined && response.exceptionClass != null)
    {
        return response.exceptionClass;
    }
    else
    {
        return null;
    }
}

export const getStackTraceFromResponse = (response) =>
{
    if (response.errorDetail !== undefined && response.errorDetail != null)
    {
        if ( response.errorDetail.trace !== undefined )
        {
            return response.errorDetail.trace;
        }
        else {
            return null ;
        }
    }
    else
    {
        return null;
    }
}
export const getErrorDetailFromResponse = (response) =>
{
    return response.errorDetail;
}

export const getDataFromResponse = (response) =>
{
    if (response.rows !== undefined && response.rows != null)
    {
        return response.rows;
    }
    else
    {
        return [];
    }
}

export const getCustomDataFromResponse = (response, data_item) =>
{
    if (response === undefined)
    {
        throw new Error("You must pass a parameter to getCustomDataFromResponse()");
    }

    if (getStatusFromResponse(response) === statusSuccess)
    {
        if (response.custom_data !== undefined)
        {
            if (response.custom_data[data_item] !== undefined)
            {
                return response.custom_data[data_item];
            }
            else
            {
                return [];
            }
        }
        else
        {
            return [];
        }
    }
    else
    {
        return [];
    }
}

export const getNamedCustomDataFromResponse = (response, itemName) =>
{
    if (response.result !== undefined && response.result != null)
    {
        if (response.custom_data !== undefined)
        {
            if (response.custom_data[itemName] !== undefined)
            {
                return response.custom_data[itemName];
            }
            else
            {
                return [];
            }
        }
        else
        {
            return [];
        }
    }
    else
    {
        return [];
    }
}

export const responseHasCustomData = (response) =>
{
    if (response.custom_data !== undefined && response.custom_data != null)
    {
        return true;
    }
    else
    {
        return false;
    }
}

export const getNumRowsFromResponse = (response) =>
{
    return response.rowsAffected;
}

//this is only used by the react register/activate form
export const checkError = (data) =>
{
    if (data != null)
    {
        if (getStatusFromResponse(data) === statusSuccess)
        {
            return true;
        }
        else
        {
            console.error(data);

            let displayMessage = '';

            const type = getExceptionClassFromResponse(data)

            if ( type !== null )
            {
                // This is a new type of error with exception type so we can make some more specific decisions

                const stackTrace = getStackTraceFromResponse( data ) ;

                if ( type.includes ( '\\APIAuthorisationException'))
                {
                    // We need to inspect the stack to see where the error actually occurred

                    let callingFunctionDetails = stackTrace[0];

                    let callingFilename = callingFunctionDetails.file ;
                    let callingFunctionName = callingFunctionDetails.function ;
                    let callingFunctionLine = callingFunctionDetails.line ;

                    if ( callingFunctionDetails.function === 'checkRights' )
                    {
                        // If we were called from checkRights, the actual culprit is the next level down
                        callingFunctionDetails = stackTrace[1] ;
                        callingFunctionName = callingFunctionDetails.function ;
                    }

                    displayMessage = "<p>Error File: " + callingFilename + '</p>';
                    displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                    displayMessage += '<p><b>Authorisation Failed</b></p>';
                }
                else if ( type.includes ( '\\APIEncryptedValueException'))
                {
                    // We need to inspect the stack to see where the error actually occurred

                    let callingFunctionDetails = stackTrace[2];

                    let callingFilename = callingFunctionDetails.file ;
                    let callingFunctionName = callingFunctionDetails.function ;
                    let callingFunctionLine = callingFunctionDetails.line ;

                    displayMessage = "<p>Error File: " + callingFilename + '</p>';
                    displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                    displayMessage += '<br><p><b>Invalid encrypted parameter passed</b></p>';
                }
                else if ( type.includes ( '\\APIParameterException'))
                {
                    // We need to inspect the stack to see where the error actually occurred

                    let detail = getErrorDetailFromResponse(data) ;

                    let callingFilename = detail.file ;
                    let callingFunctionLine = detail.line ;

                    let pExCallingFunctionDetails = stackTrace[0];

                    if ( pExCallingFunctionDetails.function === 'checkArgs')
                    {
                        callingFilename = pExCallingFunctionDetails.file ;
                        callingFunctionLine = pExCallingFunctionDetails.line
                        pExCallingFunctionDetails = stackTrace[1] ;
                    }

                    let callingFunctionName = pExCallingFunctionDetails.function ;

                    displayMessage = "<p>Error File: " + callingFilename + '</p>';
                    displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                    displayMessage += '<p><b>' + detail.message + '</b></p>';
                }
                else if ( type.includes ( 'PDOException'))
                {
                    // We need to inspect the stack to see where the error actually occurred

                    let pdoDetail = getErrorDetailFromResponse(data) ;

                    let callingFunctionDetails = stackTrace[1];

                    if ( callingFunctionDetails.function === 'bindAndExecute')
                    {
                        callingFunctionDetails = stackTrace[2] ;
                    }

                    const callingFilename = pdoDetail.file ;
                    const callingFunctionName = callingFunctionDetails.function ;
                    const callingFunctionLine = pdoDetail.line ;
                    const message = pdoDetail.message ;

                    displayMessage = "<p>Error File: " + callingFilename + '</p>';
                    displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                    displayMessage += '<p><b>' + message + '</b></p>';
                }
                else if ( type === 'Error' || type === 'ParseError' || type === 'RuntimeException' )
                {
                    // We need to inspect the stack to see where the error actually occurred

                    let detail = getErrorDetailFromResponse(data) ;

                    let callingFunctionDetails = stackTrace[0];

                    let callingFilename = detail.file ;
                    let callingFunctionName = callingFunctionDetails.function ;
                    let callingFunctionLine = detail.line ;

                    displayMessage = "<p>Error File: " + callingFilename + '</p>';
                    displayMessage += "<p>Failed in function " + callingFunctionName + '() at line ' + callingFunctionLine + '</p>';
                    displayMessage += '<p><b>' + detail.message + '</b></p>';
                }
            }
            else if (getErrorFromResponse(data) === "PDO Exception")
            {
                const details = getErrorDetailFromResponse(data);

                displayMessage = "<p>Error File: " + details.file + '</p>';
                displayMessage += "<p>Error Line: " + details.line + '</p>';
                displayMessage += '<p>' + details.message + '</p>';
            }
            else if (getErrorFromResponse(data) === "Exception" )
            {
                displayMessage = "<p>Error File: " + data.errorDetail.file + '</p>';
                displayMessage += "<p>Error Line: " + data.errorDetail.line + '</p>';
                displayMessage += '<p>' + data.errorDetail.message + '</p>';
            }
            else if (getErrorFromResponse(data) === "Invaild JWT Token")
            {
                const emailContact = '<a href="mailto:info@arcbox.co.uk">info@arcbox.co.uk</a>'
                displayMessage = "<p>Invalid Token: Your security token has expired. Please contact the person who invited you to ARCBOX. Or email  " + emailContact + '</p>';
            }
            else
            {
                displayMessage = "<p>" + data.error + "</p>";
                displayMessage += data.errorDetail !== null ? "<p>" + data.errorDetail + "</p>" : "";
            }

            bootbox.alert({
                size: "large",
                title: "The operation failed",
                message: displayMessage,
                callback: function ()
                {
                }
            })
        }
    }
    else
    {
        bootbox.alert({
            size: "large",
            title: "The operation failed",
            message: "Null Response from server",
            callback: function ()
            {
            }
        })
    }

    return false;
}

function getThisErrorObject()
{
    try
    {
        throw Error("");
    }
    catch (err)
    {
        const res = ErrorStackParser.parse(err);

        return res;
    }
}

export const handleAjaxError = (jqXHR, exception, error, returnUrl) => {
    let msg = "";
    let fullMessage = "";

    if (jqXHR.status === 0 || jqXHR.readyState === 0)
    {
        return;
    }

    console.error(jqXHR);

    if (jqXHR.status == 400)
    {
        msg = "Bad Parameters. [400]" + "</p>";

        if (jqXHR.responseJSON != null)
        {
            const status = jqXHR.responseJSON;

            if (status.error === "Exception")
            {
                fullMessage = "<p>Error File: " + status.errorDetail.file + "</p>";
                fullMessage += "<p>Error Line: " + status.errorDetail.line + "</p>";
                fullMessage += "<p>" + status.errorDetail.message + "</p>";
            }
        }
    }
    else if (jqXHR.status === 404)
    {
        if (jqXHR.responseJSON != null)
        {
            const status = jqXHR.responseJSON;

            if (status.error === "Exception")
            {
                fullMessage = "<p>Error URL: " + status.errorDetail.file + "</p>";
                fullMessage += "<p>" + status.errorDetail.message + "</p>";
            }
        }
        else
        {
            msg = "Page Not Found. [404]" + "</p>";
        }
    }
    else if (jqXHR.status === 401)
    {
        msg = "Not Authorised. [404]";
    }
    else if (jqXHR.status === 500)
    {
        msg = "Internal Server Error [500].";

        if (jqXHR.responseJSON != null)
        {
            const status = jqXHR.responseJSON;

            if (status.error === "Exception")
            {
                fullMessage = "<p>Error File: " + status.errorDetail.file + "</p>";
                fullMessage += "<p>Error Line: " + status.errorDetail.line + "</p>";
                fullMessage += "<p>" + status.errorDetail.message + "</p>";
            }
        }
        else if (jqXHR.responseText != null)
        {
            fullMessage = "<p>Error File: " + jqXHR.responseText + "</p>";
        }
    }
    else if (exception === "parsererror")
    {
        msg = "Requested JSON parse failed.";
    }
    else if (exception === "timeout")
    {
        msg = "Time out error.";
    }
    else if (exception === "abort")
    {
        msg = "Ajax request aborted.";
    }
    else
    {
        if (jqXHR.message != null)
        {
            msg = jqXHR.message;

            fullMessage = "<p>Error Stack: " + jqXHR.stack + "</p>";
        }
        else
        {
            fullMessage = "Uncaught Error.\n" + jqXHR.responseText;
        }
    }

    const stackFrames = getThisErrorObject();

    const callingFrame = stackFrames[2];

    if (fullMessage === "")
    {
        fullMessage =
            "Error occurred in function " +
            callingFrame.functionName +
            " in module " +
            callingFrame.fileName +
            " at line " +
            callingFrame.lineNumber;
    }

    if (jqXHR.status === 401)
    {
        fullMessage = "You are not authorised to perform this operation.";
    }

    bootbox.alert({
        size: "large",
        title: "The operation failed " + msg,
        message: fullMessage,
        callback: function () {
            if (returnUrl != null)
            {
                location.assign(returnUrl);
            }
        }
    });
};

